module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/appeal_point_03-59aae059d2b236790a837ce57b5ca9ee.jpg";